var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 54,
    viewBox: "0 0 52 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_1823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6867 48.8915C29.6363 51.8471 26.8613 53.9618 23.6113 53.9618C21.637 53.9618 19.687 53.1456 18.3107 51.6934C17.5099 50.9285 16.9102 49.9091 16.5601 48.865C16.8859 48.9162 17.2101 48.941 17.5602 48.9922C18.1357 49.0682 18.7354 49.1459 19.3351 49.1954C20.7599 49.3226 22.2107 49.3985 23.6598 49.3985C25.1089 49.3985 26.5094 49.3226 27.9099 49.1954C28.4351 49.1441 28.9603 49.1194 29.4595 49.0417C29.8599 48.9904 30.2603 48.9392 30.685 48.888L30.6867 48.8915Z",
    fill: "#FF7324"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2291 3.94565C26.151 3.33615 24.9099 3.00049 23.5874 3.00049C20.8626 3.00049 18.4116 4.50392 17.1116 6.87302C12.2358 9.34459 8.86098 14.4662 8.86098 20.3774V26.824C8.86098 27.8681 8.38605 29.6524 7.86085 30.5693L5.33538 34.8252C4.33525 36.5318 4.10992 38.4186 4.73565 40.1517C5.33538 41.8583 6.76018 43.1833 8.61138 43.8211C13.4612 45.503 18.5607 46.3192 23.6619 46.3192C28.7631 46.3192 33.8626 45.503 38.7124 43.8476C40.4631 43.2611 41.8134 41.9113 42.4617 40.1535C43.1117 38.3957 42.9366 36.4594 41.9624 34.827L39.463 30.5976C38.9378 29.6542 38.4628 27.8716 38.4628 26.8258V23.2836C31.4082 23.2023 25.7124 17.3476 25.7124 10.1361C25.7124 7.89769 26.2602 5.79182 27.2291 3.94742V3.94565ZM30.1983 6.87655C34.7899 9.18029 38.0469 13.8408 38.4265 19.3068C33.5419 19.2044 29.6142 15.1375 29.6142 10.1361C29.6142 8.98772 29.8205 7.88885 30.1983 6.87655Z",
    fill: "#FF7324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6112 10.1343C47.6112 15.2011 43.5812 19.3069 38.6118 19.3069C33.6423 19.3069 29.6123 15.1994 29.6123 10.1343C29.6123 5.06929 33.6406 0.961792 38.6118 0.961792C43.583 0.961792 47.6112 5.06929 47.6112 10.1343Z",
    fill: "#FF7324"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_1823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 53,
    fill: "white",
    transform: "translate(0 0.961792)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/IconNotification.3af78a4c50332defa31a5cb196b5fdfb.svg";
export { ForwardRef as ReactComponent };